export default function me(msg: string) {
    return `me ${msg}`
}